export default __webpack_public_path__ + "static/media/01.9330e03b.png";